import { render, staticRenderFns } from "./project-charter.vue?vue&type=template&id=99c64170"
import script from "./project-charter.vue?vue&type=script&lang=js"
export * from "./project-charter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports